const MissionProgress = () => {
    // Mock current mission status
    const weeklyGoal = {
        current: 7,
        target: 10,
        label: 'Weekly Posts'
    };

    const currentStreak = 12;

  return (
    <div className="bg-slate-900/50 backdrop-blur-sm p-6 rounded-2xl shadow-lg border border-slate-800 flex flex-col justify-between h-full">
        <div>
            <div className="flex items-center justify-between mb-4">
                <h3 className="font-bold text-white">Current Mission</h3>
                <div className="flex items-center gap-1 text-orange-400 bg-orange-950/30 px-2 py-1 rounded-lg border border-orange-900/50">
                    <svg className="w-4 h-4 text-orange-400 fill-orange-400" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
                    </svg>
                    <span className="font-bold text-xs">{currentStreak} day streak!</span>
                </div>
            </div>

            <div className="mb-6">
                <div className="flex justify-between text-sm mb-2">
                    <span className="text-slate-400">Weekly Goal: 10 Posts</span>
                    <span className="font-bold text-primary-400">{weeklyGoal.current}/{weeklyGoal.target}</span>
                </div>
                <div className="w-full bg-slate-800 rounded-full h-3 overflow-hidden">
                    <div 
                        className="bg-primary-500 h-3 rounded-full transition-all duration-1000 ease-out"
                        style={{ width: `${(weeklyGoal.current / weeklyGoal.target) * 100}%` }}
                    ></div>
                </div>
                <p className="text-xs text-slate-500 mt-2 text-center">
                    3 more posts to earn your weekly badge
                </p>
            </div>
        </div>

        <button className="w-full py-2.5 border-2 border-primary-500/30 text-primary-400 font-semibold rounded-xl hover:bg-primary-500/10 transition">
            View All Missions
        </button>
    </div>
  );
};

export default MissionProgress;
